// src/pages/expense/cafe/doksanDraftConfig.js
// ✅ 전 사업 확산 [5] — 카페인 독산점의 businessConfig. 가산점과 동일한 패턴
// (VendorPanel/ExpenseItemPanel/SalaryPanel도 카페 4개점 공용 컴포넌트를 그대로
// 재사용). 템플릿 15종은 DocumentTypeSelector.jsx의 "expense_draft-CAFE_INN_독산"
// 목록과 expenseTemplates.js의 doksan_* 정의를 그대로 재사용.
import { makeExpenseDraftConfig } from "../_shared/expenseDraftConfig";
import VendorPanel from "../_shared/VendorPanel";
import ExpenseItemPanel from "../_shared/ExpenseItemPanel";
import SalaryPanel from "./SalaryPanel";

// ── 15종 — Intl.Collator("ko") 정렬 검증 완료(DocumentTypeSelector.jsx와 동일 순서) ──
const TEMPLATES = [
  { code: "doksan_gas", label: "가스" },
  { code: "doksan_payroll", label: "급여지급" },
  { code: "doksan_holiday_gift", label: "명절격려품" },
  { code: "doksan_vat", label: "부가세" },
  { code: "doksan_social_insurance", label: "사회보험료" },
  { code: "doksan_goods", label: "상품구매" },
  { code: "doksan_water", label: "수도" },
  { code: "doksan_credit_card", label: "신용카드결제" },
  { code: "doksan_withholding_tax", label: "원천세" },
  { code: "doksan_hygiene_edu", label: "위생교육" },
  { code: "doksan_internet", label: "인터넷·전화요금" },
  { code: "doksan_vending_terminal", label: "자판기단말기" },
  { code: "doksan_ingredient", label: "재료구매" },
  { code: "doksan_electric", label: "전기" },
  { code: "doksan_pos_rental", label: "포스임대료" },
];

// ✅ CafeDoksanExpense 실측(56건) 근거 기본값. 데이터 근거가 없는 항목(명절격려품/
// 부가세/수도/가스/전기 일부)은 빈 값으로 둔다(자유 입력) — 완료 보고의 "임시안"
// 표시 대상.
const CATEGORY_ITEM_FIELD_DEFAULTS = {
  doksan_ingredient: { category_name: "독산점 재료비", item_name: "", field_name: "구입" },
  doksan_goods: { category_name: "상품매입비", item_name: "", field_name: "구입" },
  doksan_pos_rental: { category_name: "사무관리비", item_name: "포스 임대료", field_name: "납부" },
  doksan_internet: { category_name: "공공운영비", item_name: "인터넷 및 전화 요금", field_name: "납부" },
  doksan_credit_card: { category_name: "(정산 용도)수수료 합계", item_name: "(정산 용도)수수료 합계", field_name: "정산" },
  doksan_payroll: { category_name: "급여", item_name: "카페인 독산점 급여", field_name: "지급" },
  doksan_social_insurance: { category_name: "연금부담금 등", item_name: "사회보험료", field_name: "납부" },
  doksan_vending_terminal: { category_name: "사무관리비", item_name: "자판기용 단발기 이용료", field_name: "납부" },
  doksan_withholding_tax: { category_name: "예수금", item_name: "원천세", field_name: "납부" },
  doksan_hygiene_edu: { category_name: "교육훈련비", item_name: "휴게음식점 위생교육", field_name: "납부" },
};

const SALARY_PANEL_TEMPLATES = ["doksan_payroll"];
const GENERIC_TABLE_PANEL_TEMPLATES = [
  "doksan_pos_rental", "doksan_credit_card", "doksan_social_insurance",
  "doksan_holiday_gift", "doksan_withholding_tax", "doksan_vending_terminal",
];

const doksanDraftConfig = makeExpenseDraftConfig({
  namespace: "cafe-doksan-draft",
  category: "CAFE_INN_독산",
  businessLabel: "카페인 독산점",
  // ✅ (구) 페이지가 실제로 쓰는 CafeDoksanExpense.draft_no 접두어와 정확히 일치(DB
  // 실측: 기존 56건 전부 "금천일자리(주)CAFE_INN 독산점지출").
  draftNoPrefix: "금천일자리(주)CAFE_INN 독산점지출",
  dataApiBase: "/expense/cafe/doksan/",
  combinedCreateApi: "/expense/cafe/doksan/draft/",
  newRoutePath: "/expense/cafe/doksan/draft/new",
  listRoutePath: "/expense/cafe/doksan/draft/list",
  previewRoutePath: "/expense/cafe/doksan/draft/preview",
  templates: TEMPLATES,
  categoryItemFieldDefaults: CATEGORY_ITEM_FIELD_DEFAULTS,
  itemPanelTemplates: [],
  salaryPanelTemplates: SALARY_PANEL_TEMPLATES,
  genericTablePanelTemplates: GENERIC_TABLE_PANEL_TEMPLATES,
  VendorPanel,
  ExpenseItemPanel,
  SalaryPanel,
});

export default doksanDraftConfig;
